<script lang="ts" setup>
defineProps<{
  rounded?: boolean
  shadow?: boolean
}>()
</script>

<template>
  <div
    class="bg-white p-4 g-card"
    :class="{
      'rounded-v2lg': rounded,
      'g-card-shadow': shadow
    }"
  >
    <slot/>
  </div>
</template>

<style lang="scss">
.g-card-shadow {
  box-shadow: 10px 10px 40px rgb(0 0 0 / 5%);
}

.g-card .g-button-large {
  width: 100%;
}
</style>
